<mat-select
  [formControl]="valueControl"
  [multiple]="multiple()"
  panelClass="select-panel large-panel"
  (opened)="openDialog()"
>
  @for(option of options(); track option.value) {
    <mat-option [value]="option.value">{{option.label}}</mat-option>
  }
</mat-select>
